import { Button, ButtonProps, Icon } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";
import { IconType } from "react-icons";
import { Tooltip } from "../ui/tooltip";

interface Props extends ButtonProps {
  label: string;
  icon?: IconType;
  tooltipContent?: string;
}

function CustomButton({
  icon,
  colorPalette,
  label,
  tooltipContent,
  ...props
}: Props) {
  const colors = useThemeColors();
  return (
    <Tooltip content={tooltipContent || label}>
      <Button
        colorPalette={colorPalette || colors.schoolAccent.primary}
        bgGradient={!props.variant || props.variant === "solid" ? "linear(to-br, brand.500, brand.600)" : undefined}
        boxShadow={!props.variant || props.variant === "solid" ? "0 2px 8px rgba(0, 209, 193, 0.3)" : undefined}
        transition="all 0.2s ease"
        _hover={{
          transform: "translateY(-1px)",
          boxShadow: !props.variant || props.variant === "solid" ? "0 4px 12px rgba(0, 209, 193, 0.4)" : undefined,
          bgGradient: !props.variant || props.variant === "solid" ? "linear(to-br, brand.600, brand.700)" : undefined,
        }}
        _active={{
          transform: "translateY(0)",
          boxShadow: !props.variant || props.variant === "solid" ? "0 1px 4px rgba(0, 209, 193, 0.2)" : undefined,
        }}
        {...props}
      >
        {icon && <Icon as={icon} />}
        {label}
      </Button>
    </Tooltip>
  );
}

export default CustomButton;
